module.exports = __webpack_public_path__ + "static/media/shop_vector.ec71cb1f.svg";